import { createAction, handleActions } from 'redux-actions'
import update from 'immutability-helper'
import { LocaleType, PACKAGE_NAME } from './types'

const UPDATE_STATE = `${PACKAGE_NAME}_UPDATE_STATE`

const initState = {
  locale: LocaleType.ZH_CN,

}


export type CommonState = typeof initState

function setState<T> (state: CommonState, field: string, value: T): CommonState {
  if (!state.hasOwnProperty(field)) {
    console.error(`package-${PACKAGE_NAME}-reducer[ERROR]: can't find ${field} property`)
  }
  
  return update(state, { [field]: { $set: value } })
}


export const commonReducer = handleActions<CommonState>({
  [UPDATE_STATE] (state,  { payload }) {
      let s = state
      for (let key in payload) 
        s = setState(s, key, payload[key])
      
      return s
  },
  
}, initState)

export const updateStateAction = createAction(UPDATE_STATE)
export const updateState = params => dispatch => {
  dispatch(updateStateAction(params))
}